var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
// External dependencies
import { Dialog, DialogTitle, Box, Typography, DialogContent, DialogActions, Button, Grid, IconButton, } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { Clear, EmojiObjectsOutlined } from '@mui/icons-material';
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { useFormik } from "formik";
import * as yup from 'yup';
// Interal dependencies
import { appStyles } from "../App.styles";
import { ButtonSG, TextFieldSG, ChatPromptIconSG, LoadingButtonSG } from "../components";
import { UserContext, getAuthHeader } from "../auth";
import { axiosClient } from "../axios";
import { ENDPOINTS, LOG_LEVELS, SERVICES } from "../constants";
export const CreateBrandVoiceDialog = ({ createDialogOpen, handleNewClickClose, inputBrandVoice, outputLanguage, reloadBrandVoicesFlag, setReloadBrandVoicesFlag, }) => {
    // Get user credential
    const user = useContext(UserContext);
    // Step 1: Detect brand voice
    // Step 2: Save/ Edit brand voice
    const [step, setStep] = useState(1);
    const { t, i18n } = useTranslation();
    useEffect(() => {
        // Initialize data
        // The existed brand voice
        if (createDialogOpen && inputBrandVoice) {
            setStep(2);
            formik2.resetForm();
            formik1.resetForm();
            formik2.setValues({ name: inputBrandVoice === null || inputBrandVoice === void 0 ? void 0 : inputBrandVoice.name, content: inputBrandVoice === null || inputBrandVoice === void 0 ? void 0 : inputBrandVoice.content });
            return;
        }
        if (createDialogOpen) {
            setStep(1);
            formik1.resetForm();
            formik2.resetForm();
        }
    }, [createDialogOpen]);
    function detectAgain() {
        setStep(1);
        formik1.resetForm();
    }
    ;
    function saveBrandVoice() {
        var _a, _b, _c;
        return __awaiter(this, void 0, void 0, function* () {
            try {
                // Get auth header
                const authHeader = yield getAuthHeader(user);
                const headers = Object.assign(Object.assign({}, authHeader), { 'Accept-Language': i18n.language });
                // Get brand voice
                let brandVoice = Object.assign({}, formik2.values);
                if (inputBrandVoice === null || inputBrandVoice === void 0 ? void 0 : inputBrandVoice._id) {
                    //create new brand voice
                    yield axiosClient.put(`${process.env.SERVER_URL}${ENDPOINTS.CHAT}${ENDPOINTS.UPDATE_BRAND_VOICE}/${inputBrandVoice === null || inputBrandVoice === void 0 ? void 0 : inputBrandVoice._id}`, { brandVoice }, { headers });
                }
                else {
                    // create new brand voice
                    yield axiosClient.post(`${process.env.SERVER_URL}${ENDPOINTS.CHAT}${ENDPOINTS.CREATE_BRAND_VOICE}`, { brandVoice }, { headers });
                }
                ;
                handleNewClickClose();
                setReloadBrandVoicesFlag(reloadBrandVoicesFlag + 1);
            }
            catch (err) {
                axiosClient.post(`${process.env.LOGGER_SERVER_URL}${ENDPOINTS.LOGGER}${ENDPOINTS.LOG}`, {
                    level: LOG_LEVELS.ERROR,
                    logMessage: `createBrandVoiceDialog, saveBrandVoice, ${err === null || err === void 0 ? void 0 : err.message}`,
                    metadata: {
                        env: process.env.ENV,
                        service: SERVICES.DOCUMENTS,
                        userId: user === null || user === void 0 ? void 0 : user.uid,
                        email: user === null || user === void 0 ? void 0 : user.email,
                        userAgent: navigator === null || navigator === void 0 ? void 0 : navigator.userAgent,
                    },
                });
                // Check if the error is from axios
                if ((_a = err === null || err === void 0 ? void 0 : err.response) === null || _a === void 0 ? void 0 : _a.status) {
                    // If yes, notify user with the server error message
                    toast.error((_c = (_b = err === null || err === void 0 ? void 0 : err.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.message);
                    return;
                }
                ;
                handleNewClickClose();
                toast.error(t('Something went wrong. We are figuring it out.'));
            }
            ;
        });
    }
    function detectBrandVoice() {
        var _a, _b, _c, _d, _e, _f;
        return __awaiter(this, void 0, void 0, function* () {
            try {
                // Get auth header
                const authHeader = yield getAuthHeader(user);
                const headers = Object.assign(Object.assign({}, authHeader), { 'Accept-Language': i18n.language });
                const body = { description: (_a = formik1 === null || formik1 === void 0 ? void 0 : formik1.values) === null || _a === void 0 ? void 0 : _a.description, outputLanguage };
                // Call detect brand voice API
                const res = yield axiosClient.post(`${process.env.SERVER_URL}${ENDPOINTS.CHAT}${ENDPOINTS.DETECT_BRAND_VOICE}`, { description: (_b = formik1 === null || formik1 === void 0 ? void 0 : formik1.values) === null || _b === void 0 ? void 0 : _b.description, outputLanguage }, { headers });
                // Extract total, documents
                const { content } = (_c = res === null || res === void 0 ? void 0 : res.data) === null || _c === void 0 ? void 0 : _c.data;
                formik2.setValues({ name: '', content });
                setStep(2);
            }
            catch (err) {
                axiosClient.post(`${process.env.LOGGER_SERVER_URL}${ENDPOINTS.LOGGER}${ENDPOINTS.LOG}`, {
                    level: LOG_LEVELS.ERROR,
                    logMessage: `createBrandVoiceDialog, detectBrandVoice, ${err === null || err === void 0 ? void 0 : err.message}`,
                    metadata: {
                        env: process.env.ENV,
                        service: SERVICES.DOCUMENTS,
                        userId: user === null || user === void 0 ? void 0 : user.uid,
                        email: user === null || user === void 0 ? void 0 : user.email,
                        userAgent: navigator === null || navigator === void 0 ? void 0 : navigator.userAgent,
                    },
                });
                // Check if the error is from axios
                if ((_d = err === null || err === void 0 ? void 0 : err.response) === null || _d === void 0 ? void 0 : _d.status) {
                    // If yes, notify user with the server error message
                    toast.error((_f = (_e = err === null || err === void 0 ? void 0 : err.response) === null || _e === void 0 ? void 0 : _e.data) === null || _f === void 0 ? void 0 : _f.message);
                    return;
                }
                ;
                toast.error(t('Something went wrong. We are figuring it out.'));
            }
            ;
        });
    }
    const [
    /** Detect brand voice loading */ detectLoading, setDetectLoading] = useState(false);
    // Validate schema
    const validationSchema1 = yup.object({
        description: yup
            .string()
            .required('Required'),
    });
    const validationSchema2 = yup.object({
        name: yup
            .string()
            .required('Required'),
        content: yup
            .string()
            .required('Required'),
    });
    // Initialize Formik
    const formik1 = useFormik({
        initialValues: {
            description: ''
        },
        validationSchema: validationSchema1,
        validateOnChange: false,
        onSubmit: (values) => __awaiter(void 0, void 0, void 0, function* () {
            try {
                setDetectLoading(true);
                yield detectBrandVoice();
            }
            catch (err) {
                axiosClient.post(`${process.env.LOGGER_SERVER_URL}${ENDPOINTS.LOGGER}${ENDPOINTS.LOG}`, {
                    level: LOG_LEVELS.ERROR,
                    logMessage: `createBrandVoiceDialog, formik1, onSubmit, ${err === null || err === void 0 ? void 0 : err.message}`,
                    metadata: {
                        env: process.env.ENV,
                        service: SERVICES.AI_CHAT,
                        userId: null,
                        email: null,
                        userAgent: navigator === null || navigator === void 0 ? void 0 : navigator.userAgent,
                    },
                });
                toast.error(t('Something went wrong. We are figuring it out.'));
            }
            setDetectLoading(false);
        })
    });
    const formik2 = useFormik({
        initialValues: {
            name: '',
            content: '',
        },
        validationSchema: validationSchema2,
        validateOnChange: false,
        onSubmit: (values) => __awaiter(void 0, void 0, void 0, function* () {
            try {
                saveBrandVoice();
            }
            catch (err) {
                axiosClient.post(`${process.env.LOGGER_SERVER_URL}${ENDPOINTS.LOGGER}${ENDPOINTS.LOG}`, {
                    level: LOG_LEVELS.ERROR,
                    logMessage: `createBrandVoiceDialog, formik2, onSubmit, ${err === null || err === void 0 ? void 0 : err.message}`,
                    metadata: {
                        env: process.env.ENV,
                        service: SERVICES.AI_CHAT,
                        userId: null,
                        email: null,
                        userAgent: navigator === null || navigator === void 0 ? void 0 : navigator.userAgent,
                    },
                });
                toast.error(t('Something went wrong. We are figuring it out.'));
            }
        })
    });
    const BrandVoiceTip = () => {
        return _jsxs(Box, Object.assign({ sx: {
                color: '#082018',
                boxShadow: 'none',
                textTransform: 'none',
                backgroundColor: '#CEE9DD',
                borderRadius: '8px',
                padding: '1rem',
            } }, { children: [_jsxs(Box, Object.assign({ sx: {
                        display: 'flex',
                        paddingLeft: '0.5rem'
                    } }, { children: [_jsx(EmojiObjectsOutlined, {}), _jsx(Typography, Object.assign({ sx: Object.assign(Object.assign({}, appStyles.text14), { textAlign: 'left', color: '#000000', marginLeft: '0.5rem', marginTop: '0.1rem' }) }, { children: t('Tips for adding Brand Voice') }))] })), _jsx(Typography, Object.assign({ sx: Object.assign(Object.assign({}, appStyles.text14), { textAlign: 'left', color: '#000000', marginLeft: '0.5rem', marginTop: '0.1rem' }) }, { children: _jsxs("ul", Object.assign({ style: { margin: '0 0 0 -1rem' } }, { children: [_jsx("li", Object.assign({ style: { marginTop: '0px' } }, { children: t("Write or paste content (100 - 500 words) that represents your brand's unique voice.") })), _jsx("li", Object.assign({ style: { marginTop: '0px' } }, { children: t("Click 'Detect Brand Voice' and let AI do the work for you.") }))] })) }))] }));
    };
    const DialogHeader = () => {
        return (_jsxs(Grid, Object.assign({ container: true, sx: { padding: '0 0 1.5rem' } }, { children: [_jsx(Grid, Object.assign({ item: true, xs: true, sx: {
                        display: 'flex',
                        alignItems: 'center',
                    } }, { children: _jsx(Typography, Object.assign({ sx: {
                            padding: '0',
                            fontWeight: '400',
                            fontSize: '1.75rem',
                            lineHeight: '2.25rem',
                            color: '#000000',
                        } }, { children: t('Add Brand Voice') })) })), _jsx(Grid, Object.assign({ item: true, sx: { display: 'flex', alignItems: 'center' } }, { children: _jsx(IconButton, Object.assign({ onClick: handleNewClickClose }, { children: _jsx(Clear, { sx: { color: '#1C1B1F' } }) })) }))] })));
    };
    return (_jsxs(Dialog
    // Create dialog
    , Object.assign({ 
        // Create dialog
        sx: {
            '& .MuiDialog-paper': {
                backgroundColor: '#ffffff',
                borderRadius: '1rem',
                maxWidth: '1024px',
                width: '100%',
                height: {
                    sm: '80%',
                    xs: '90%',
                },
            }
        }, open: createDialogOpen, onClose: handleNewClickClose }, { children: [step === 1 &&
                _jsxs("form", Object.assign({ onSubmit: formik1.handleSubmit }, { children: [_jsx(Box, { children: _jsxs(DialogTitle, Object.assign({ sx: {
                                    padding: {
                                        sm: '1.5rem 1.5rem 0',
                                        xs: '0.5rem 0.5rem 0',
                                    }
                                } }, { children: [_jsx(DialogHeader, {}), _jsx(BrandVoiceTip, {})] })) }), _jsx(DialogContent, Object.assign({ sx: {
                                padding: {
                                    sm: '1.5rem 1.5rem 0',
                                    xs: '0.5rem 0.5rem 0',
                                }
                            } }, { children: _jsx(TextFieldSG
                            // Description text field
                            , { 
                                // Description text field
                                name: 'description', label: t("Content to Analyze"), placeholder: t("Paste any content (i.e. blog article, social media post, website copy, marketing emails) that represent your brand voice."), rows: 10, multiline: true, 
                                // value={content}
                                value: formik1.values.description, onChange: formik1.handleChange, error: formik1.touched.description && Boolean(formik1.errors.description), helperText: formik1.touched.description && formik1.errors.description }) })), _jsx(DialogActions, Object.assign({ sx: {
                                padding: {
                                    sm: '0 1.5rem 1.5rem',
                                    xs: '0 .5rem .5rem',
                                },
                            } }, { children: _jsx(LoadingButtonSG
                            // New button
                            , Object.assign({ 
                                // New button
                                variant: "contained", loading: detectLoading, type: "submit", startIcon: _jsx(ChatPromptIconSG, { sx: {
                                        color: 'white.main',
                                        width: '1.125rem',
                                        height: '1.125rem',
                                    } }) }, { children: t('Detect Brand Voice') })) }))] })), step === 2 &&
                _jsxs("form", Object.assign({ onSubmit: formik2.handleSubmit }, { children: [_jsx(Box, { children: _jsx(DialogTitle, Object.assign({ sx: {
                                    padding: '1.5rem 1.5rem 0rem',
                                } }, { children: _jsx(DialogHeader, {}) })) }), _jsxs(DialogContent, Object.assign({ sx: { padding: '1.5rem 1.5rem 0' } }, { children: [_jsx(TextFieldSG
                                // Name text field
                                , { 
                                    // Name text field
                                    name: 'name', label: "Brand Voice Name", value: formik2.values.name, onChange: formik2.handleChange, error: formik2.touched.name && Boolean(formik2.errors.name), helperText: formik2.touched.name && formik2.errors.name }), _jsx(TextFieldSG
                                // brand Voice Content text field
                                , { 
                                    // brand Voice Content text field
                                    name: 'content', label: t("Brand Voice"), rows: 10, multiline: true, value: formik2.values.content, onChange: formik2.handleChange, error: formik2.touched.content && Boolean(formik2.errors.content), helperText: formik2.touched.content && formik2.errors.content })] })), _jsxs(DialogActions, Object.assign({ sx: {
                                padding: '0 1.5rem 1.5rem',
                            } }, { children: [_jsx(Button
                                // Detect Brand Voice button
                                , Object.assign({ 
                                    // Detect Brand Voice button
                                    variant: "outlined", sx: Object.assign(Object.assign({}, appStyles.text14), { border: '1px solid #707974', borderRadius: '100px', textTransform: 'none', alignItems: 'center', textAlign: 'center', padding: '0.625rem 1.5rem 0.625rem 1rem', backgroundColor: 'transparent', color: '#006B54', boxSizing: 'border-box' }), onClick: detectAgain, startIcon: _jsx(ChatPromptIconSG, { sx: {
                                            color: 'green.main',
                                            width: '1.125rem',
                                            height: '1.125rem',
                                        } }) }, { children: t('Detect Again') })), _jsx(ButtonSG
                                // Detect Brand Voice button
                                , Object.assign({ 
                                    // Detect Brand Voice button
                                    variant: "contained", type: "submit" }, { children: t('Save') }))] }))] }))] })));
};
